import api from "@/router/api"

export default {
    getAllResponsibles({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesResponsibleVhe.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_RESPONSIBLES', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener los responsables',
                })
            })
        })
    },
}
